import React, { useCallback, useEffect, useRef, useState } from 'react';

export const AudioPlayer = (props) => {
    const { location } = props;
    const { mp3, mp3Length } = location;

    const audioRef = useRef(null);
    const playerProgressRef = useRef(null);
    const playerTimeCurrentRef = useRef(null);
    const playerTimeDurationRef = useRef(null);
    const playerProgressFilledRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const isPreview = mp3.includes('Preview');

    // Display currentTime and duration properties in real-time
    const setTimes = useCallback(() => {
        playerTimeCurrentRef.current.textContent = new Date(audioRef.current.currentTime * 1000)
            .toISOString()
            .substr(11, 8);
        if (audioRef.current.duration) {
            playerTimeDurationRef.current.textContent = new Date(audioRef.current.duration * 1000)
                .toISOString()
                .substr(11, 8);
        }
        else {
            playerTimeDurationRef.current.textContent = mp3Length || '00:00:00';
        }
    }, [mp3Length]);

    // Update player timeline progress visually
    const progressUpdate = useCallback(() => {
        const percent = (audioRef.current.currentTime / audioRef.current.duration) * 100;
        playerProgressFilledRef.current.style.flexBasis = `${percent}%`;
    }, []);

    const clickPlayAudioBtn = useCallback(() => {
        if (isPlaying) {
            audioRef.current.pause();
        }
        else {
            audioRef.current.play();
        }

        setIsPlaying(!isPlaying);
    }, [isPlaying]);

    // Scrub player timeline to skip forward and back on click for easier UX
    const scrub = useCallback((ev) => {
        const offsetX = (ev.nativeEvent && ev.nativeEvent.offsetX) != null ? ev.nativeEvent.offsetX : ev.offsetX;
        if (!isNaN(audioRef.current.duration) && !isNaN(offsetX)) {
            audioRef.current.currentTime = (offsetX / playerProgressRef.current.offsetWidth) * audioRef.current.duration;
        }
    }, []);

    // Reset audio player on mp3 change
    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0; // Reset time
            audioRef.current.load(); // Reload the audio element
            setIsPlaying(false); // Reset play state
            // playerTimeDurationRef.current.textContent = mp3Length || '00:00:00';
            // audioRef.current.addEventListener('canplaythrough', () => {
            //     console.log('Audio loaded:', mp3);
            // });
        }
    }, [mp3]);

    // Add event listeners on mount and cleanup on unmount
    useEffect(() => {
        const audio = audioRef.current;

        const handleTimeUpdate = () => {
            progressUpdate();
            setTimes();
        };

        audio.addEventListener('timeupdate', handleTimeUpdate);
        // playerTimeDurationRef.current.textContent = mp3Length || '00:00:00';

        return () => {
            audio.removeEventListener('timeupdate', handleTimeUpdate);
        };
    }, [mp3, progressUpdate, setTimes]);

    if (!mp3) {
        console.error('Missing mp3');
        return null;
    }

    return (
        <div className="audio-player-card card mb-3 float-end" key={mp3}>
            <audio key={mp3} id={mp3} preload="none" ref={audioRef}>
                <source src={`./mp3/${mp3}`} type="audio/mpeg" />
            </audio>
            <div className="card-header">{isPreview ? 'Preview this Story' : 'Listen to the Story'}</div>
            <div className="card-body">
                <div className="row g-0">
                    <div className="col align-content-center">
                        <div className="player-timeline">
                            <span ref={playerTimeCurrentRef} className="player-time player-time-current">00:00:00</span>
                            <div className="player-progress" ref={playerProgressRef} onClick={scrub}>
                                <div ref={playerProgressFilledRef} className="player-progress-filled"></div>
                            </div>
                            <span ref={playerTimeDurationRef} className="player-time player-time-duration">{mp3Length}</span>
                        </div>
                    </div>
                    <div className="col audio-play-btn-col">
                        <button
                            className={`audio-play-btn btn-square btn-solid-lg float-end ${isPlaying ? 'bi-pause-fill' : 'bi-play-fill'}`}
                            onClick={clickPlayAudioBtn}
                        ></button>
                    </div>
                </div>
                {/*<div className="row g-0">
                    <div className="col">
                        <a className="float-end" href={bandcampURL}>Purchase on Bandcamp</a>
                    </div>
                </div>*/}
            </div>

            {/*            <div className="row g-0">
                <div className="col">
                    <iframe src="https://bandcamp.com/EmbeddedPlayer/album=1009616040/size=large/bgcol=ffffff/linkcol=333333/tracklist=false/artwork=small/transparent=true/" seamless
                            title="My Name Is New York (Audiobook) by Nora Guthrie &amp; Woody Guthrie"><a
                        href="https://woodyguthriemusic.bandcamp.com/album/my-name-is-new-york-audiobook">My Name Is New York (Audiobook) by Nora Guthrie &amp; Woody Guthrie</a></iframe>
                </div>
            </div>*/}
        </div>
    );
};
